module.exports = __webpack_public_path__ + "img/60.55d0de2a.jpg";